const CoverageCheckMapID = "CoverageMap";

const DeliveryFormFields = {
  name: "delivery",
  map_id: "delivery",
  fields: {
    delivery_address: {
      default: "",
      value: "",
      type: "address",
      required : true,
      // required: Storage.get("use_same_location") === true ? true : false,
    },
    delivery_address_coordinates: {
      default: null,
      value: null,
      type: "latlng",
      required : true,
      // required: Storage.get("use_same_location") === true ? true : false,
    },
    // address_2: {
    //   default: "",
    //   value: "",
    //   type: "text",
    //   required: true,
    // },
    customer_name: {
      default: "",
      value: "",
      type: "text",
      validation: "max_10",
      required: true,
    },
    instructions: {
      default: "",
      value: "",
      type: "text",
      validation: "max_50",
      required: false,
    },
    selected_country: {
      default: "AE",
      value: "AE",
      type: "country",
      required: true,
      dependent: "phone",
    },
    phone: {
      default: "",
      value: "",
      type: "phone_short",
      mask: [/\d/, " ", /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/],
      required: true,
      dependency: "selected_country",
    },
    location_type: {
      default: "",
      value: "",
      type: "text",
      required: true,
    },
    street: {
      default: "",
      value: "",
      type: "text",
      // validation: "max_10",
      required: true,
    },
    building: {
      default: "",
      value: "",
      type: "text",
      validation: "max_30",
      required: true,
    },
    // if apartment / office
    floor: {
      default: "",
      value: "",
      type: "text",
      validation: "max_10",
      required: false,
    },
    unit: {
      default: "",
      value: "",
      type: "text",
      validation: "max_10",
      required: false,
    },
     emirate : {
      default: "",
      value: "",
      type: "text",
      required: true,
    },
    area : {
      default: "",
      value: "",
      type: "text",
      required: false,
    },
    neighborhood : {
      default: "",
      value: "",
      type: "text",
      required: false,
    },
  },
};

const PaymentCommonFormFields = {
  name: "payment_common",
  map_id: null,
  fields: {
    agree: {
      default: "",
      value: false,
      type: "checkbox",
      required: true,
    },
    router_locked: {
      default: "",
      value: false,
      type: "checkbox",
      required: true,
    },
    newsletter: {
      default: "",
      value: false,
      type: "checkbox",
      required: false,
    }
  },
};

const PaymentCardFormFields = {
  name: "payment_card",
  map_id: null,
  fields: {
    card_number: {
      default: "",
      value: "",
      type: "card",
      required: true,
      result: null,
      dependent: "card_security_code",
      next_focus: "card_holder_name",
    },
    card_holder_name: {
      default: "",
      value: "",
      type: "card_holder_name",
      required: true,
    },
    expiry_date: {
      default: "",
      value: "",
      type: "card_expiry_date",
      required: true,
      next_focus: "card_security_code",
    },
    card_security_code: {
      default: "",
      value: "",
      type: "cvv",
      required: true,
      dependency: "card_number",
    },
    save_card: {
      default: "",
      value: true,
      type: "checkbox",
      required: false,
    },
  },
};

export {
  DeliveryFormFields,
  CoverageCheckMapID,
  PaymentCardFormFields,
  PaymentCommonFormFields,
};
